import { useForm } from "react-hook-form";
import { IntegrationCreatedSection } from "../sections/IntegrationCreatedSection";
import { Loading } from "../components/Loading";
import { useClickCreateConnectionUx } from "../logic/hooks/ux/useClickCreateConnectionUx";
import { ConnectionFormSection } from "../sections/ConnectionFormSection";
import { useGetConnectionDefinition } from "../logic/hooks/useGetConnectionDefinition";
import { IntegrationIncompleteSection } from "../sections/IntegrationIncompleteSection";
import { EmptyState } from "../components/EmptyState";
import { ConnectionFailedSection } from "../sections/ConnectionFailedSection";

export const ControlledConnectionForm = ({
  definitionId,
  setIntegrationId,
  selectedConnection,
  showNameInput,
  connectionGuide,
  requestId,
  linkHeaders,
  isWhiteLabel,
}: {
  definitionId: number;
  setIntegrationId: (id: number | undefined) => void;
  selectedConnection?: number | string;
  showNameInput?: boolean;
  connectionGuide?: string;
  requestId?: number;
  linkHeaders?: Record<string, unknown>;
  isWhiteLabel?: boolean | null;
}) => {
  const { definition, isLoading } = useGetConnectionDefinition({
    definitionId,
    linkHeaders,
  });

  const {
    trigger,
    isLoading: isProcessing,
    response,
    errorMessage,
    sessionExpired,
  } = useClickCreateConnectionUx(linkHeaders);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const handleClickBack = async () => {
    setIntegrationId(undefined);
  };

  const handleClose = async () => {
    window?.parent?.postMessage(
      {
        messageType: "EXIT_EVENT_LINK",
      },
      "*"
    );
  };

  const onSubmit = (data: { [K: string]: unknown }) => {
    if (definition) {

      trigger({
        authForm: data,
        connectionDefinitionId: definition?.id,
        requestId,
      });
    }
  };

  return (
    <>
    {sessionExpired && (
        <ConnectionFailedSection
          errorMessage="The session has expired. Please try again."
          onClose={handleClose}
          onClick={handleClickBack}
          onBack={handleClickBack}
          isConnectionSelected={!!selectedConnection}
        />
      )}
      {isLoading && !sessionExpired && <Loading  onClose={handleClose} />}
      {isProcessing && !sessionExpired && <Loading message="Setting up your integration..." onClose={handleClose} />}
      {response && !sessionExpired && <IntegrationCreatedSection onClose={handleClose} />}
      {definition?.oauth && !sessionExpired && <IntegrationIncompleteSection onClose={handleClose} />}
      {!isLoading && !isProcessing && !response && definition && !definition?.oauth && !sessionExpired && (
        <ConnectionFormSection
          onSubmit={onSubmit}
          definition={definition}
          onBack={selectedConnection ? undefined : handleClickBack}
          onClose={handleClose}
          register={register}
          control={control}
          handleSubmit={handleSubmit}
          errors={errors}
          error={errorMessage}
          showNameInput={showNameInput}
          isConnectionSelected={!!selectedConnection}
          helperLink={connectionGuide === "" ? undefined : (connectionGuide || definition?.frontend?.spec?.helperLink)}
          isWhiteLabel={isWhiteLabel}
        />
      )}
      {!isLoading && !isProcessing && !response && !definition && !sessionExpired && (
        <EmptyState 
          message="This platform does not exist" 
          onClose={handleClose}
        />
      )}
    </>
  );
};
